// React imports
import React from 'react';
import { Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

// Material-UI imports
import {
  Paper,
  Button,
  CssBaseline,
  TextField,
  Typography,
  Container,
  Box,
} from '@material-ui/core';

// Other imports
// @ts-ignore
import { yupResolver } from '@hookform/resolvers/yup';
// @ts-ignore
import * as yup from 'yup';

// Absolute imports
import Logo from 'assets/Diligent_Equity.png';
import { routes } from 'routes';
import getVersion from 'utils/version';

// Relative imports
import { usePasswordResetPage } from './usePasswordResetPage';
import useStyles from './PasswordResetStyles';

export function PasswordResetPage() {
  const classes = useStyles();
  const history = useHistory();
  const logic = usePasswordResetPage();

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper variant="outlined" square className={classes.paper} classes={{
        root: 'lens-login-form',
      }}>
        <img src={Logo} alt="logo" className={classes.logo} />
        {!logic.email ? (
          <form className={classes.form} onSubmit={logic.getOnSubmit()}>
            <label className={`${classes.inputLabel} lens-ee-label lens-m-0`}>
              Enter the email address associated with your account to reset your
              password.
            </label>
            <Controller
              name="email"
              control={logic.form.control}
              render={(props) => (
                <TextField
                  {...props}
                  error={!!logic.form.errors.email}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  autoComplete="email"
                  autoFocus
                  helperText={logic.form.errors.email?.message || ' '}
                  classes={{
                    root: classes.formControl,
                  }}
                />
              )}
            />
            <Box display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Continue
              </Button>
            </Box>
          </form>
        ) : (
          <div style={{ width: '100%' }}>
            <label className={classes.inputLabel}>
              If an account exists for{' '}
              <a href={`mailto:${logic.email}`}>{logic.email}</a>, a password
              reset email has been sent. Please use the link sent in the email
              to create a new password.
            </label>
            <Box display="flex" justifyContent="flex-end">
              <Button
                type="button"
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => history.push(routes.LOGIN)}
              >
                Back to Login
              </Button>
            </Box>
          </div>
        )}
        <div style={{ width: '100%' }}>
          <Box display="flex" justifyContent="flex-end">
            <Typography
              variant="body2"
              color="textPrimary"
              align="right"
              className={classes.version}
            >
              {getVersion()}
            </Typography>
          </Box>
        </div>
      </Paper>
    </Container>
  );
}
